import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { IconButton, Menu, MenuItem } from '@material-ui/core'
import { mdiTrayArrowDown } from '@mdi/js'
import Icon from '@mdi/react'
import { ExportFileIcon } from './export-icon'
import { DownloadIcon } from 'lucide-react'

const useStyles = makeStyles(theme => ({
    menuItem: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        fontSize: 14
    },
    iconButton: {
        margin: theme.spacing(1)
    }
}))

export const ExportMenu = ({ children }) => {
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = useState(null)

    const handleClick = event => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <>
            <IconButton className={classes.iconButton} onClick={handleClick}>
                <DownloadIcon size={20} />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {children({
                    handleClose,
                    anchorEl,
                    setAnchorEl
                })}
            </Menu>
        </>
    )
}

ExportMenu.Csv = ({ locale, onExport }) => {
    const classes = useStyles()
    return (
        <MenuItem onClick={() => onExport('csv')} className={classes.menuItem}>
            {locale.common.exportCsv}
            <ExportFileIcon fileType="csv" locale={locale} />
        </MenuItem>
    )
}

ExportMenu.Excel = ({ locale, onExport }) => {
    const classes = useStyles()
    return (
        <MenuItem onClick={() => onExport('xlsx')} className={classes.menuItem}>
            {locale.common.exportExcel}
            <ExportFileIcon fileType="excel" locale={locale} />
        </MenuItem>
    )
}

ExportMenu.Pdf = ({ locale, onExport }) => {
    const classes = useStyles()
    return (
        <MenuItem onClick={() => onExport('pdf')} className={classes.menuItem}>
            {locale.common.exportPdf}
            <ExportFileIcon fileType="pdf" locale={locale} />
        </MenuItem>
    )
}
